/* eslint-disable react/prop-types */
import Button from 'components/base/Button';
import gsap from 'gsap';
import { useEffect, useState } from 'react';

const LoadingButton = ({
  primaryText,
  loadingText,
  isLoading,
  idClass,
  className,
  buttonId = 'buttonLoading',
  ...props
}) => {
  const [isFirstTime, setIsFirstTime] = useState(true);
  const timeline = gsap.timeline();
  useEffect(() => {
    const primary = `.primaryLd${idClass}`;
    const loading = `.Loading${idClass}`;
    if (isLoading) {
      timeline.to(primary, { y: -50, opacity: 0, duration: 0.5 });
      timeline.fromTo(
        loading,
        { y: 50, opacity: 0 },
        { y: '-50%', opacity: 1 },
        '-=0.5'
      );
    } else {
      if (!isFirstTime) {
        timeline.fromTo(
          loading,
          { y: '-50%', opacity: 1 },
          { y: '150%', opacity: 0, duration: 0.5 }
        );
        timeline.to(primary, { y: 0, opacity: 1 }, '-=0.5');
      } else {
        setIsFirstTime(false);
      }
    }
  }, [isLoading]);

  return (
    <Button
      className={`d-block position-relative button-loading-slide ${className}`}
      style={{ transition: 'background-color 300ms easeIn' }}
      id={buttonId}
      {...props}
    >
      <div className="slide text-center">
        <div className={`primaryLd${idClass}`}>{primaryText}</div>
        <div className={`Loading${idClass} LoadingText`}>{loadingText}</div>
      </div>
    </Button>
  );
};

export default LoadingButton;
